import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-session-expiration-modal',
  templateUrl: './session-expiration-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: `
    img {
      width: 150px;
      height: 110px;
    }
    button {
      width: fit-content;
    }
  `
})
export class SessionExpirationModalComponent {
  constructor(private dialogRef: MatDialogRef<SessionExpirationModalComponent>) {}

  continueSession() {
    this.dialogRef.close(true);
  }

  logout() {
    this.dialogRef.close();
  }
}
